import { useCallback } from 'react';
import useGameContext from '../context/GameContext';
import usePlayerContext from '../context/PlayerContext';
import { analytics } from '../services/analytics';
import { AnswerType, QuestionType } from '../types/entities';

export const useAnalytics = () => {
  const { playerRef } = usePlayerContext();
  const { gameSessionRef } = useGameContext();

  const onQuestionShown = useCallback((question: QuestionType) => {
    const updatedGameSession = gameSessionRef.current;
    const player = playerRef.current;
    if (!player || !updatedGameSession) return;
    analytics.onQuestionShown({ player, gameSession: updatedGameSession, question });
  }, []);

  const onQuestionAnswered = useCallback((question: QuestionType, answer: AnswerType) => {
    const updatedGameSession = gameSessionRef.current;
    const player = playerRef.current;
    if (!player || !updatedGameSession) return;
    analytics.onQuestionAnswered({
      player,
      gameSession: updatedGameSession,
      question,
      answer,
    });
  }, []);

  const onTimeout = useCallback((question: QuestionType) => {
    const updatedGameSession = gameSessionRef.current;
    const player = playerRef.current;
    if (!player || !updatedGameSession) return;
    analytics.onTimeout({ player, gameSession: updatedGameSession, question });
  }, []);

  const onResult = useCallback(() => {
    const updatedGameSession = gameSessionRef.current;
    const player = playerRef.current;
    if (!player || !updatedGameSession) return;
    analytics.onResult({ player, gameSession: updatedGameSession });
  }, []);

  return {
    onQuestionShown,
    onQuestionAnswered,
    onTimeout,
    onResult,
  };
};
